import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { Api } from '@/core/api.js'
const api = new Api()

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context(
    '../locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  )
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })

  console.log(messages)
  return messages
}

const i18n = new VueI18n({
  locale: 'init',
  fallbackLocale: 'init',
  messages: loadLocaleMessages(),
  silentTranslationWarn: true
})

i18n.loadLanguageAsync = function (lang) {
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return api.get('miclive/language/' + lang).then(function (response) {
        i18n.setLocaleMessage(lang, response)
        loadedLanguages.push(lang)
        console.log(response)
        return setI18nLanguage(lang)
      })
        .catch(() => {
          return setI18nLanguage('es')
        })
    }
    return Promise.resolve(setI18nLanguage(lang))
  }
  return Promise.resolve(lang)
}

export default i18n

const loadedLanguages = ['init'] // our default language that is preloaded

function setI18nLanguage (lang) {
  i18n.locale = lang
  // axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}
